import { FC, Suspense, useState } from 'react';
import ProgressStudentTablesHeader from './ProgressStudentTablesHeader';
import ProgressStudentSnapshotTable from './ProgressTables/ProgressStudentSnapshotTable';
import ProgressStudentGrowthTable from './ProgressTables/ProgressStudentGrowthTable';
import ProgressStudentRoadmapProgressTable from './ProgressTables/ProgressStudentRoadmapProgressTable';
import { useQueryLoader } from 'react-relay';
import { getStudentGrowthAndEngagement, getStudentRoadmapByGrade } from '../../graphQLOperations/Progress';
import { ProgressStudentsRoadmapByGradeQuery } from '../../graphQLOperations/__generated__/ProgressStudentsRoadmapByGradeQuery.graphql';
import { ProgressStudentsGrowthAndEngagementQuery } from '../../graphQLOperations/__generated__/ProgressStudentsGrowthAndEngagementQuery.graphql';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';

export enum ProgressStudentSelector {
  SNAPSHOT = 0,
  GROWTH_AND_ENGAGEMENT = 1,
  ROADMAP_PROGRESS_BY_GRADE = 2,
}

interface Props {
  selector?: ProgressStudentSelector;
}

const ProgressStudentTablesContainer: FC<Props> = ({ selector }) => {
  const [headerSelector, setHeaderSelector] = useState<ProgressStudentSelector>(ProgressStudentSelector.SNAPSHOT);
  const active = selector ?? headerSelector;
  const [roadmapQueryRef, loadRoadmapQuery] =
    useQueryLoader<ProgressStudentsRoadmapByGradeQuery>(getStudentRoadmapByGrade);
  const [growthQueryRef, loadGrowthQuery] =
    useQueryLoader<ProgressStudentsGrowthAndEngagementQuery>(getStudentGrowthAndEngagement);
  return (
    <>
      <div className={selector === undefined ? '' : 'tw-hidden'}>
        <Suspense fallback={<ThreeDotLoader />}>
          <ProgressStudentTablesHeader
            headerSelector={active}
            tracked={selector === undefined}
            setHeaderSelector={setHeaderSelector}
            loadRoadmapQuery={loadRoadmapQuery}
            loadGrowthQuery={loadGrowthQuery}
          />
        </Suspense>
      </div>
      {active === ProgressStudentSelector.SNAPSHOT && <ProgressStudentSnapshotTable />}
      {active === ProgressStudentSelector.GROWTH_AND_ENGAGEMENT && (
        <ProgressStudentGrowthTable growthQueryRef={growthQueryRef} />
      )}
      {active === ProgressStudentSelector.ROADMAP_PROGRESS_BY_GRADE && (
        <ProgressStudentRoadmapProgressTable roadmapQueryRef={roadmapQueryRef} />
      )}
    </>
  );
};

export default ProgressStudentTablesContainer;
